"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("rect", {
      x: "3.0918",
      y: "2.70215",
      width: "14.4121",
      height: "14.4121",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "4.15039",
      cy: "5.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "4.15039",
      cy: "11.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "7.65039",
      cy: "5.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "7.65039",
      cy: "11.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "11.1504",
      cy: "5.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "11.1504",
      cy: "11.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "14.6504",
      cy: "5.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "14.6504",
      cy: "11.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "5.95117",
      cy: "14.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "9.45117",
      cy: "14.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "12.9512",
      cy: "14.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "16.4512",
      cy: "14.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "5.95117",
      cy: "8.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "9.45117",
      cy: "8.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "12.9512",
      cy: "8.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "16.4512",
      cy: "8.25",
      r: "0.75",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.40039 2.5L17.6233 16.2049",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M13 2.5L17.5 10",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.4996 17.5L3.09961 3.5",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M15 17.5L6 2.5",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M7.99922 17.5L3.19922 9.5",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.5 2.5L3.2 13",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.90039 2.5L3.20039 7",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M7.40039 17.5L16.4004 2.5",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M3.90039 17.5L12.9004 2.5",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.8997 17.5001L17.5957 6.34009",
      stroke: "currentColor",
      strokeWidth: "0.5"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.5 17.5L17.5 12.5",
      stroke: "currentColor",
      strokeWidth: "0.5"
    })]
  });
};

exports.default = Icon;